import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from 'shared/store';

export const financeOperatorsApi = createApi({
  reducerPath: 'financeOperatorsApi',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['FinanceOperations', 'FinanceOperationId'],
  endpoints: () => ({}),
});
